import { useMemo } from "react";
import MeasurementService from "services/MeasurementService";
import useQuery from "hooks/useQuery";
import useQueryStatusBuilder from "hooks/useQueryStatusBuilder";

interface AthletesMeasurementsCountOptions {
  enabled?: boolean;
}

function useGetAthletesMeasurementsCount(ids: Array<string>, options?: AthletesMeasurementsCountOptions) {
  const { enabled = true } = options ?? {};

  const key = useMemo(() => {
    if (!enabled) return null;
    if (!ids.length || ids.length === 0) return null;
    return ["MeasurementService.getAthletesMeasurementCount", ids] as const;
  }, [enabled, ids]);

  const { data, error, isLoading } = useQuery(key, ([_, athleteIds]) =>
    MeasurementService.getAthletesMeasurementCount(athleteIds)
  );

  const status = useQueryStatusBuilder({ isLoading, isError: !!error });

  return useMemo(() => ({ data: data ?? { count: 0 }, status }), [data, status]);
}

export default useGetAthletesMeasurementsCount;
